import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  tripsList: [],
  tripsById: {},
  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    assign: false,
    upload: false,
  },
  error: false,
  errorMessage: "",
};

const tripsSlice = createSlice({
  name: "trips",
  initialState,
  reducers: {
    getTripsList(state, action) {
      state.tripsList = action.payload;
      state.loading.read = false;
      state.error = null;
    },
    getTripsByIdData(state, action) {
      state.tripsById = action.payload;
      state.loading.getById = false;
      state.error = null;
    },
    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getTripsList,
  getTripsByIdData,
  errorMessages,
  hideErrorMessage,
  setLoading,
} = tripsSlice.actions;

export default tripsSlice.reducer;
